import Plotly from "./components/Plotly.vue";
export {
    Plotly
};